import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Inflamation from './components/Inflamation'
import ResultsInterpretation from './components/ResultsInterpretation'
import RecomendAndNextSteps from './components/RecomendAndNextSteps'

const Background = styled.div`
  height: 100%;
  width: 100%;
`

interface TemplateV1EntryProps {
  info: any
  themeId: number | null
}

const TemplateV1Entry: React.FC<TemplateV1EntryProps> = ({ info, themeId }) => {
  const effectiveThemeId = themeId ?? null
  const { t } = useTranslation()
  const [isModalOpen, setIsOpenModal] = useState(false)

  const handleModalOpen = () => setIsOpenModal(true)

  if (!info) {
    return (
      <div style={{ padding: '40px 0', textAlign: 'center', color: '#888' }}>
        No report data available
      </div>
    )
  }

  return (
    <Background>
      <Inflamation themeId={effectiveThemeId} info={info}/>
      <div className={'page-break'}></div>
      <ResultsInterpretation themeId={effectiveThemeId} info={info}></ResultsInterpretation>
      <RecomendAndNextSteps themeId={effectiveThemeId} info={info}></RecomendAndNextSteps>
    </Background>
  )
}

export default TemplateV1Entry
